import { Component, OnInit, OnDestroy } from '@angular/core';
import { Translators } from '@services/shared/translators.service';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { User } from '@interfaces/interface-bakend/seguridad/users/user.interface';
import { UsuarioService } from '@services/shared/usuario.service';
import { AuthService } from '@services/auth/auth.service';
import { GecrosAfiliadosService } from 'src/app/services/entidades/gecros-afiliados.service';
import { SignoGecrosAfiliado } from 'src/app/interfaces/interface-bakend/entidades/signo-greco-afiliado.interface';
import { GuiMsjService } from '@services/shared/gui-msj.service';
import { PreviousRouteService } from '@services/shared/previous-route.service';
import Swal from 'sweetalert2';
import { formatDate } from '@angular/common';
import { AppConfigService } from '@services/shared/app-config.service copy';
import { SignoSedeService } from '@services/entidades/signo-sedes.service';
import { GecrosSyncService } from '@services/entidades/gecros-sync.service';

@Component({
    selector: 'app-credencial',
    templateUrl: './credencial.component.html',
    styleUrls: ['./credencial.component.scss'],
})
export class CredencialComponent implements OnInit, OnDestroy {
    idioma: Subscription;
    user: User;
    afiliadoFromGecros: SignoGecrosAfiliado;
    flagDataGecros: boolean = false;
    estados: string[] = ['Con Cobertura', 'Sin Cobertura'];
    routes: { url: string; label: string }[] = [];
    currentDate: string;

    /**
     * La credencial está conformada en tres partes:
     * n°sede(tres dígitos) - n° de documento del afiliado - parentesco(dos dígitos)
     */
    numeroAfiliado: string = '';

    //prestador santa fe
    isSantaFe: boolean = false;

    bgImage = [
        {
            background: 'assets/img/signo-medico/bg-credencial-profile-2.jpg',
            credencial: 'assets/img/signo-medico/bg-credencial.png',
        },
    ];

    credencialImg = [
        {
            credencial: 'assets/img/credencial/credencial-signo-tres.jpg',
            logo: 'assets/logos/logo-solapa.png',
        },
    ];

    showPatologiasModal: boolean = false;

    // ==== Control de vigencia ====
    serverNow!: Date; // Hora del servidor al cargar
    validoHasta!: Date; // Fecha/hora de vencimiento
    isExpired = false; // Flag de vencida
    expiryHours = 24; // Ventana de validez (por defecto 24h)
    private expiryTimer?: ReturnType<typeof setInterval>;

    constructor(
        private router: Router,
        private previousRouteService: PreviousRouteService,
        private authService: AuthService,
        private translatorService: Translators,
        private perfilesService: PerfilesService,
        private userService: UsuarioService,
        private gecrosAfiliadosService: GecrosAfiliadosService,
        private guiMsjService: GuiMsjService,
        private appConfigService: AppConfigService,
        private signoSedeService: SignoSedeService,
        private gecrosSyncService: GecrosSyncService
    ) {
        // this.idioma = this.translatorService.getIdiomaSeleccionado().subscribe(resp => {
        //   this.idioma = resp;
        // });

        this.getUser();
    }

    ngOnInit(): void {
        this.getfechaValidez();
        this.perfilesService.allowedByUserLogon(this.router.url);
        this.previousRouteService
            .getRoutes()
            .subscribe((routes) => {
                this.routes = routes;
            })
            .unsubscribe();
    }

    ngOnDestroy(): void {
        if (this.expiryTimer) {
            clearInterval(this.expiryTimer);
        }
    }

    /**
     * Obtiene hora del servidor y define ventana de validez.
     * Formatea "Válido hasta" y setea el watcher de vencimiento.
     */
    async getfechaValidez() {
        try {
            const dateString: string =
                await this.appConfigService.getServerTime(); // ISO 8601
            this.serverNow = new Date(dateString);

            // Si tenés una fecha real de vigencia desde GECROS (p. ej. afiliadoFromGecros.vigenteHasta),
            // reemplazá la siguiente línea por: this.validoHasta = new Date(this.afiliadoFromGecros.vigenteHasta);
            this.validoHasta = new Date(
                this.serverNow.getTime() + this.expiryHours * 60 * 60 * 1000
            );

            // Mostrar "Válido hasta" con fecha y hora (dd-MM-yyyy HH:mm)
            const dd = String(this.validoHasta.getDate()).padStart(2, '0');
            const mm = String(this.validoHasta.getMonth() + 1).padStart(2, '0');
            const yyyy = this.validoHasta.getFullYear();
            const hh = String(this.validoHasta.getHours()).padStart(2, '0');
            const min = String(this.validoHasta.getMinutes()).padStart(2, '0');
            this.currentDate = `${dd}-${mm}-${yyyy} ${hh}:${min}`;

            // Evaluar ahora y refrescar cada 30s
            this.checkExpiry();
            if (this.expiryTimer) clearInterval(this.expiryTimer);
            this.expiryTimer = setInterval(() => this.checkExpiry(), 30_000);
        } catch (error) {
            console.error('Error al obtener la fecha del servidor:', error);
            this.currentDate = 'Error al obtener la fecha del servidor';
        }
    }

    /**
     * Revisa si venció comparando contra el "reloj" a partir de serverNow (evita drift).
     * Actualiza únicamente el flag isExpired; NO modifica el estado de GECROS.
     */
    private checkExpiry() {
        if (!this.serverNow || !this.validoHasta) return;

        const elapsed = Date.now() - this.serverNow.getTime();
        const nowFromServerOrigin = new Date(
            this.serverNow.getTime() + elapsed
        );

        this.isExpired = nowFromServerOrigin >= this.validoHasta;

        // Importante: NO sobrescribir afiliadoFromGecros.estado
        // El estado real de cobertura se conserva tal como lo devuelve GECROS.
    }

    /**
     * Obtiene usuario completo y arma credencial (GECROS / local)
     */
    async getUser() {
        try {
            const identificacion = this.userService.getIdentificacionUsuario();

            console.log('Identificación recibida:', identificacion);

            await this.guiMsjService.msjFormSubmit('Espere');
            Swal.showLoading();

            const usuario = await this.userService.getFindOneByIdentification(
                identificacion
                    ? identificacion
                    : await this.authService.getIdentificacion()
            );

            console.log('Usuario obtenido:', usuario);
            this.user = usuario;

            await this.obtenerSedeUsuario(this.user._id);

            await this.credencialAfiliadoConFormato(
                identificacion
                    ? identificacion
                    : await this.authService.getIdentificacion()
            );

            this.userService.setUserLogged(true);
        } catch (error) {
            console.error('Error al obtener el afiliado:', error);
        } finally {
            Swal.close();
        }
    }

    /*
     * La credencial del afiliado se crea a partir de los datos de GECROS
     */
    async credencialAfiliadoConFormato(identificacionAfiliado: string) {
        try {
            const isGecrosAvailable =
                await this.gecrosAfiliadosService.statusGecros();

            if (isGecrosAvailable) {
                const resp =
                    await this.gecrosAfiliadosService.getAfiliadoByIdentificacion(
                        identificacionAfiliado
                    );
                if (resp.data && resp.data.length > 0) {
                    this.afiliadoFromGecros = resp.data[0];
                    this.flagDataGecros = true;

                    // Mantener nuestra DB en sync con GECROS (plan + cobertura).
                    // No bloquea el render: la credencial ya muestra el dato fresco.
                    this.gecrosSyncService
                        .sincronizarAfiliado(this.user?._id, this.afiliadoFromGecros, this.user)
                        .catch((error) =>
                            console.error('Error al sincronizar GECROS desde la credencial:', error)
                        );

                    // Si tu backend provee una fecha de vigencia real, podés setearla acá:
                    // if (this.afiliadoFromGecros?.vigenteHasta) {
                    //   this.validoHasta = new Date(this.afiliadoFromGecros.vigenteHasta);
                    //   // Recalcular currentDate con esa fecha
                    //   const dd = String(this.validoHasta.getDate()).padStart(2, '0');
                    //   const mm = String(this.validoHasta.getMonth() + 1).padStart(2, '0');
                    //   const yyyy = this.validoHasta.getFullYear();
                    //   const hh = String(this.validoHasta.getHours()).padStart(2, '0');
                    //   const min = String(this.validoHasta.getMinutes()).padStart(2, '0');
                    //   this.currentDate = `${dd}-${mm}-${yyyy} ${hh}:${min}`;
                    //   this.checkExpiry();
                    // }
                } else {
                    this.flagDataGecros = false;
                    this.afiliadoFromGecros = undefined;
                    await this.gecrosCaido();
                }
            } else {
                await this.gecrosCaido();
            }

            Swal.close();

            // Formateo del número de afiliado con guiones
            if (this.afiliadoFromGecros?.numeroAfiliado) {
                const numeroAfiliado = this.afiliadoFromGecros.numeroAfiliado;
                this.numeroAfiliado = `${numeroAfiliado.slice(
                    0,
                    3
                )}-${numeroAfiliado.slice(3, 11)}-${numeroAfiliado.slice(11)}`;
                this.flagDataGecros = true;
            } else {
                this.flagDataGecros = false;
            }
        } catch (error) {
            console.error(
                `Se ha producido un error al intentar formar la credencial del afiliado con identificacion ${this.user?.identificacion}`,
                error
            );
            await this.gecrosCaido();
        }
    }

    async gecrosCaido() {
        console.log('GECROS CAÍDO');
        this.afiliadoFromGecros =
            await this.userService.getFindOneDatosGecrosLocal(this.user._id);
    }

    getCurrentDate(): string {
        const date = new Date();
        return formatDate(date, 'dd/MM/yyyy', 'en-US');
    }

    verPatologias() {
        if (this.isExpired) {
            Swal.fire({
                icon: 'warning',
                title: 'Credencial vencida',
                text: 'Tu credencial ya no está vigente. Renovala para continuar.',
                confirmButtonText: 'Entendido',
            });
            return;
        }
        this.showPatologiasModal = true;
    }

    cerrarPatologias() {
        this.showPatologiasModal = false;
    }

    private async obtenerSedeUsuario(userId: string) {
        try {
            console.log('🔍 Obteniendo sedes para usuario:', userId);
            const usuarioCompleto = await this.userService.getFindOne(userId);

            if (
                !usuarioCompleto?.signoSedes ||
                !Array.isArray(usuarioCompleto.signoSedes)
            ) {
                this.isSantaFe = false;
                return;
            }

            for (const sedeItem of usuarioCompleto.signoSedes) {
                const sedeId = this.extraerSedeId(sedeItem);
                if (!sedeId) continue;

                const sedeDetalle = await this.signoSedeService.getSedeById(sedeId);
                if (sedeDetalle?.codigoGecro === '080') {
                    this.isSantaFe = true;
                    console.log('✅ Usuario tiene sede Santa Fe');
                    return;
                }
            }

            this.isSantaFe = false;
            console.log('❌ Usuario NO tiene sede Santa Fe');
        } catch (error) {
            console.error('❌ Error al obtener sedes del usuario:', error);
            this.isSantaFe = false;
        }
    }

    private extraerSedeId(sedeItem: any): string | null {
        if (typeof sedeItem === 'string') return sedeItem;
        if (sedeItem && sedeItem._id) {
            return typeof sedeItem._id === 'string'
                ? sedeItem._id
                : String(sedeItem._id);
        }
        return null;
    }

}